<template>

  <div id="confirm-quotation-dialog" class="ui small modal confirm-quotation-modal">

    <div class="ui header">
      Geração de Pedido de Vendas
    </div>

    <div class="content">

      <form class="ui form" @submit.prevent="onConfirm()">                
        <div class="fields">
          <div class="sixteen wide field">
            <label class="form-label">Cliente</label>
            <input type="text" readonly="readonly" :value="quotation ? quotation.customer.name : ''">
          </div>
        </div>
        <div class="fields">
          <div class="five wide field">
            <label class="form-label">Entrega Padrão</label>
            <div class="ui input left icon">
              <i class="calendar icon"></i>
              <input type="text" readonly="readonly" :value="quotation ? $formatDate(quotation.standardDelivery) : ''">
            </div>
          </div>
          <div class="six wide field">
            <label class="form-label">Tipo Entrega</label>
            <select id="select-delivery-type" class="ui fluid dropdown" v-model="deliveryType">
              <option value="">Selecione...</option>     
              <option value="1">Imediata</option>              
              <option value="2">Programada</option>              
            </select>
          </div>
          <div class="five wide field">
            <label class="form-label">Fat. a Partir De</label>
            <date-picker ref="billingDatePicker" @onChange="onChangeBillingDate" :autoInit="false" :readonly="deliveryType == '1'" />
          </div>
        </div>
      </form>

    </div>

    <div class="actions">
      <button class="ui cancel basic button">
        <i class="times icon"></i>
        Cancelar
      </button>
      <button type="button" class="ui blue button" :class="{ loading }" @click="onConfirm()">
        <i class="check icon"></i>
        Confirmar
      </button>
    </div>

  </div>    

</template>

<script>

  import Message from "@/utils/message"
  import DatePicker from "@/components/date-picker.vue"
  import QuotationService from "@/services/quotation-service"

  export default {

    data() {
      return {
        loading: false,
        deliveryType: "",
        billingDate: null,
      }
    },

    props: ["quotation"],   
    
    components: {
      DatePicker,
    },

    watch: {

      "deliveryType" () {

        if (this.deliveryType == "1") {
          this.$refs.billingDatePicker.setDate(new Date())          
        } else {
          this.$refs.billingDatePicker.setDate(null)
        }
      },
    },

    mounted() {              
      
      $("#select-delivery-type").dropdown()      
      
      $("#confirm-quotation-dialog").modal({ 
        autofocus: false,
        onVisible: () => this.$refs.billingDatePicker.initCalendar()
      })

    },
    
    beforeDestroy() {
      $(".confirm-quotation-modal").remove()
    },

    methods: {

      show() {
        $("#confirm-quotation-dialog").modal("show")
      },

      hide() {
        $("#confirm-quotation-dialog").modal("hide")
      },

      onChangeBillingDate(date) {
        this.billingDate = date
      },

      async onConfirm() {

        if (!this.validData())
          return

        const { isIssueReport, isPallets, isPartialBilling, customerSalesOrder,
                shippingMessage, invoiceMessage } = this.quotation

        const salesOrderData = {
          deliveryType: this.deliveryType,
          billingDate: this.billingDate,
          isIssueReport,
          isPallets,
          isPartialBilling,
          customerSalesOrder,
          shippingMessage,
          invoiceMessage,
        }

        const data = {
          quotationId: this.quotation.id,
          salesOrderData,
        }

        this.loading = true

        try {

          await QuotationService.confirm(data)

          this.hide()

          this.$emit("onConfirm")

          this.loading = false
          this.deliveryType = ""
          this.billingDate = null          
          
        } catch (error) {
          
          this.loading = false

          this.$errorHandler(error)
        }        
      },

      validData() {

        let isOk = true
        let message = ""

        if (!this.deliveryType) {
          message = "Informe o tipo de entrega" 
        } else if (this.deliveryType == "2" && !this.billingDate) {
          message = "Informe a data de faturamento"
        }

        if (message) {
          isOk = false
          Message.info(message)
        }

        return isOk
      },
    },    
  }

</script>

